# Welcome to Kana Practice Helper!

This tool helps you improve your Japanese kana handwriting by:

* Analyzing your handwritten characters
* Providing detailed feedback on stroke order and form
* Suggesting personalized practice exercises
* Identifying similar characters to study